import React from "react";
import ListCard from "../../components/UI/ListCard/ListCard";
import styles from "./CargaDocumental.module.scss";
import Button from "../../components/UI/Button/Button";
import {DocumentosUtils} from "../../util/DocumentosUtils";

const CargaDocumentalForm = (
  {
    docsAfiliado,
    docsEmpleador,
    docsApoderado,
    docsBeneficiario,
    docsReclamante,
    docsCurador,
    formatos,
    docsBeneficiariosPropietarios,
    docsReclamantesPropietarios,
    docsCuradoresPropietarios,
    docsApoderadosPropietarios,
    docsEmpleadoresPropietarios,
    generarFilaDocumento,
    handleSubmit,
    values,
    handleGoBack,
    loader,
    disabled,
    form
  }) => {
  return (
    <>
      <form onSubmit={handleSubmit}>

        {docsAfiliado.length > 0 &&
          <ListCard id="cdDocsAfiliadoLs" title="Documentos del Afiliado">
            {docsAfiliado.map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </ListCard>
        }

        {(docsEmpleador.length > 0 && docsEmpleadoresPropietarios.length > 0) &&
        docsEmpleadoresPropietarios.map(docOwner =>
          <ListCard key={docOwner.id}
                    id={"cdDocsEmpleadorLs" + docOwner.id}
                    title={"Documentos del Empleador " +
                    DocumentosUtils.generarNombrePropietario(docOwner.propietario)}>
            {docsEmpleador
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </ListCard>
        )}

        {(docsBeneficiario.length > 0 && docsBeneficiariosPropietarios.length > 0) &&
        docsBeneficiariosPropietarios.map(docOwner =>
          <ListCard key={docOwner.id}
                    id={"cdDocsBeneficiarioLs" + docOwner.id}
                    title={"Documentos del Beneficiario " +
                    DocumentosUtils.generarNombrePropietario(docOwner.propietario)}>
            {docsBeneficiario
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </ListCard>
        )}

        {(docsReclamante.length > 0 && docsReclamantesPropietarios.length > 0) &&
        docsReclamantesPropietarios.map(docOwner =>
          <ListCard key={docOwner.id}
                    id={"cdDocsReclamanteLs" + docOwner.id}
                    title={"Documentos del Reclamante " +
                    DocumentosUtils.generarNombrePropietario(docOwner.propietario)}>
            {docsReclamante
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </ListCard>
        )}

        {(docsApoderado.length > 0 && docsApoderadosPropietarios.length > 0) &&
        docsApoderadosPropietarios.map(docOwner =>
          <ListCard key={docOwner.id}
                    id={"cdDocsApoderadoLs" + docOwner.id}
                    title={"Documentos del Apoderado " +
                    DocumentosUtils.generarNombrePropietario(docOwner.propietario)}>
            {docsApoderado
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </ListCard>
        )}

        {(docsCurador.length > 0 && docsCuradoresPropietarios.length > 0) &&
        docsCuradoresPropietarios.map(docOwner =>
          <ListCard key={docOwner.id}
                    id={"cdDocsCuradorLs" + docOwner.id}
                    title={"Documentos del Curador " +
                    DocumentosUtils.generarNombrePropietario(docOwner.propietario)}>
            {docsCurador
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </ListCard>
        )}

        {formatos.length > 0 &&
        <ListCard id="cdFormatosLs" title="Formatos">
          {formatos.map(doc => generarFilaDocumento(doc, values, form.mutators, true))}
        </ListCard>
        }

        <div className="row justify-content-center">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
            <div className={styles.FooterButtonContainer}>
              <Button
                id="cdVolverBtn"
                name="cdVolverBtn"
                type="button"
                typeStyle="ghost"
                height="48"
                onClick={handleGoBack}
              >
                Volver
              </Button>
            </div>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
            <div className={styles.FooterButtonContainer}>
              <Button
                id="cdEnviarBtn"
                name="cdEnviarBtn"
                type="submit"
                typeStyle="primary"
                height="48"
                loader={loader}
                disabled={disabled}>
                Enviar documentos
              </Button>
            </div>
          </div>
        </div>

      </form>
    </>
  );
};

export default CargaDocumentalForm;
